export default function CardArticle(params) {
    return (
        <div className="card">
            <div className="">
                <img className="img-card" src="./images/code-1839406_1280.jpg" />
            </div>
            <h1>8 دلیل نرسیدن به موقع سر فلان چیز</h1>
            <p>نمکنبتهخص صهالهعص صاعهصلتا هصصخقهعصل
                تا خصهلصقالصال عصقلقالعصلاصع
                ل صاال
                هعصع قصالعقصال عقصلاعالقاعصلاصق اقصالعاصق لاع</p>
        </div>
    )
}